import * as React from 'react';
import { Button, EmptyState, InboxIcon, Skeleton, Spinner } from '@repo/ui-web';
import { spinnerSizes } from '../../catalog/component-states';
import { StateToggle } from '../../components/StateToggle';

type SpinnerSize = (typeof spinnerSizes)[number];

export function LoadingShowcase() {
  const [size, setSize] = React.useState<SpinnerSize>('md');

  return (
    <div className="space-y-8">
      <div className="space-y-4">
        <StateToggle options={spinnerSizes} value={size} onChange={setSize} label="Spinner size" />
        <Spinner size={size} />
      </div>

      <div className="space-y-2">
        <Skeleton className="h-4 w-2/3" />
        <Skeleton className="h-4 w-1/2" />
        <Skeleton className="h-10 w-full" />
      </div>

      <div className="space-y-2">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">
          EmptyState
        </p>
        <EmptyState
          icon={<InboxIcon className="size-icon-xl" />}
          title="No messages"
          description="Your inbox is empty. New messages will appear here."
          action={
            <Button size="md" variant="outline">
              Refresh
            </Button>
          }
        />
      </div>
    </div>
  );
}
